import { BookingEmbed, Btn, Card, ExternalLink, Icon, Section } from '@ui/library';

interface ContactRowProps {
  iconName: string;
  label: string;
  sub: string;
  href: string;
  external?: boolean;
}

function ContactRow({ iconName, label, sub, href, external }: ContactRowProps) {
  const inner = (
    <>
      <span className="ic"><Icon name={iconName} size={18} /></span>
      <span>{label}<span className="sub">{sub}</span></span>
      <Icon name="arrow-up-right" size={16} />
    </>
  );
  if (external) {
    return <ExternalLink href={href}>{inner}</ExternalLink>;
  }
  return <a href={href}>{inner}</a>;
}

export interface ContactCopy {
  eyebrow: string;
  title: string;
  /** May contain HTML (e.g. <strong>). Rendered with dangerouslySetInnerHTML. */
  intro: string;
  rows: {
    emailLabel: string;
    linkedinLabel: string;
    linkedinSub: string;
    githubLabel: string;
    githubSub: string;
    xLabel: string;
    resumeLabel: string;
    resumeSub: string;
  };
  calendar: {
    bookLabel: string;
    introLabel: string;
    duration: string;
    openCalendarLabel: string;
    embedTitle: string;
  };
}

export interface ContactProps {
  email: string;
  linkedinHref: string;
  githubHref: string;
  xHref: string;
  xHandle: string;
  resumeHref: string;
  bookingHref: string;
  bookingEmbedSrc: string;
  copy: ContactCopy;
  avatarSrc?: string;
}

export function Contact({
  email,
  linkedinHref,
  githubHref,
  xHref,
  xHandle,
  resumeHref,
  bookingHref,
  bookingEmbedSrc,
  copy,
  avatarSrc = '/assets/alison-avatar.png',
}: ContactProps) {
  return (
    <Section
      id="contact"
      className="contact"
      eyebrow={copy.eyebrow}
      title={copy.title}
    >
      <div className="contact__grid" style={{ marginTop: 36 }}>
        <div className="contact__left reveal">
          <p dangerouslySetInnerHTML={{ __html: copy.intro }} />
          <div className="contact__rows">
            <ContactRow iconName="mail"      label={copy.rows.emailLabel}    sub={email}                       href={`mailto:${email}`} />
            <ContactRow iconName="linkedin"  label={copy.rows.linkedinLabel} sub={copy.rows.linkedinSub}       href={linkedinHref} external />
            <ContactRow iconName="github"    label={copy.rows.githubLabel}   sub={copy.rows.githubSub}         href={githubHref} external />
            <ContactRow iconName="twitter"   label={copy.rows.xLabel}        sub={`@${xHandle}`}               href={xHref} external />
            <ContactRow iconName="file-text" label={copy.rows.resumeLabel}   sub={copy.rows.resumeSub}         href={resumeHref} external />
          </div>
        </div>

        <Card variant="cal">
          <div className="cal__head">
            <img className="ava" src={avatarSrc} alt="Alison Haire" />
            <div>
              <span>{copy.calendar.bookLabel}</span>
              <b>{copy.calendar.introLabel}</b>
            </div>
            <span className="dur"><Icon name="clock" size={14} />{copy.calendar.duration}</span>
          </div>
          <div className="cal__body">
            <BookingEmbed
              src={bookingEmbedSrc}
              title={copy.calendar.embedTitle}
              height={600}
            />
            <div style={{ padding: '12px 16px', textAlign: 'center' }}>
              <Btn kind="ghost" href={bookingHref} icon="arrow-up-right" target="_blank">
                {copy.calendar.openCalendarLabel}
              </Btn>
            </div>
          </div>
        </Card>
      </div>
    </Section>
  );
}
